// extracted by mini-css-extract-plugin
module.exports = {"prices_and_plans_hero_section":"PricesAndPlansHero_prices_and_plans_hero_section__TYwEd"};